<template>
  <div></div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

const PAYMENT_TYPES = ['qiwi', 'yoomoney', 'yookassa'];

export default {
  name: 'SecureCallback',
  created() {
    console.log('SecureCallback::created', this.$route.query);

    if (!this.$route.query.action) {
      return;
    }

    if (PAYMENT_TYPES.includes(this.$route.query.action)) {
      this.SET_TRANSACTION({
        ...this.TRANSACTION,
        id: this.$route.query.id,
        processToken: this.$route.query.processToken,
      });
      console.log('TRANSACTION', this.TRANSACTION);
    }
  },
  mounted() {
    // TODO: @danealton второй аргумент '*' в postMessage может открыть дыру для межсайтового скриптинга
    // https://developer.mozilla.org/ru/docs/Web/API/Window/postMessage
    console.log('SecureCallback::mounted', this.$route.name);
    parent.postMessage({ result: this.$route.name }, '*');
  },
  computed: {
    ...mapState(['TRANSACTION']),
  },
  methods: {
    ...mapMutations(['SET_TRANSACTION']),
  },
};
</script>
